<template>
  <div class="pb-container">
    <div class="pull-left d-block w-100">
      <upsell>
        <h2 class="pull-left pb-title col-sm-8 col-xs-12 pl-0 fs-5" slot="product_name">RapidSSL Wildcard</h2>
        <span class="pull-left d-block w-100 mb-30" slot="description">{{ $t('upsell.rapid_wildcard_description') }}</span>
        <div class="price pull-left col-xs-12 pt-md-3 pt-2 pl-0 mb-4 fs-5" slot="price">$149.99 /yr</div>
        <a href="/plan-builder/add-product-uri?product_name=ssl.rapid_wildcard_dv&term=1&quantity=1" class="btn-os btn-outline-success btn pull-left-sm text-bold order-sm-1" slot="add-to-cart-button" v-track="{ category: 'plan-builder', action: 'click', label: 'upsell_rapid_wildcard_button' }">{{ $t('upsell.add_to_cart') }}</a>
      </upsell>
    </div>
  </div>
</template>

<script>
import Upsell from './Upsell';

export default {
  name: 'RapidWildcardUpsell',

  components: {
    Upsell
  }
};
</script>
